import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';

const QuotPatternView = () => {
    const [formData, setFormData] = useState({
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        profit: '',
        loss: '',
        quotNo: ''
    });
    const { Id } = useParams();
    const [materialList, setMaterialList] = useState([]);
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchQuotViewlist(Id));
    }, [Id, dispatch]);

    useEffect(() => {
        if (viewlist?.data && viewlist?.data?.length > 0) {
            const item = viewlist?.data[0];
            setFormData(prev => ({
                ...prev,
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
                // profit: item.profit || '',
                scrTomil: item.scrtomil || 0,
                milToparty: item.miltoparty || 0,
                loss: item.loss || '',
                quotNo: item.quotNo || '',
                retailerId: item.retailerId,
                retailerNm: item.retailerNm,
                retailerPer: item.retailerPer,
                mrpPer: item.mrpPer,
                groupId: item.groupId
            }));
            const matlist = viewlist?.material;
            setMaterialList(matlist);
        }
    }, [viewlist]);
    // console.log(materialList)



    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Quotation Material View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 2%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Item Name</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Quot. No.</td>

                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.quotNo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm Name</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                                </tr>

                                <tr>

                                    <td style={{ width: '200px', paddingLeft: '2%' }}>
                                        Cloth Out Source <br />
                                        <span style={{ color: 'red' }}>(Main + Matching %)</span>
                                    </td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.outSrc}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>

                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.mcloth} <b>Panna:{formData.mpanna}</b> <b className='red-color'>Rate:{formData.mrate}</b></td>
                                    {formData.m1cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1cloth} <b>Panna: {formData.m1panna}</b> <b className='red-color'> Rate: {formData.m1rate}</b></td>
                                        </>
                                    )}
                                </tr>
                                <tr>

                                    {formData.m2cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2cloth} <b>Panna: {formData.m2panna}</b> <b className='red-color'> Rate: {formData.m2rate}</b></td>
                                        </>
                                    )}

                                    {formData.m3cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3cloth} <b>Panna: {formData.m3panna}</b> <b className='red-color'> Rate: {formData.m3rate}</b></td>
                                        </>
                                    )}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px' }}>School</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>SCR To MIL (%)</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.scrTomil}</td>
                                    <td style={{ width: '200px' }}>MIL To Party (%)</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.milToparty}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Retailer</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData?.retailerNm}</td>
                                    <td style={{ width: '200px' }}>Value of Loss +</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.loss}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Group ID</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData?.groupId}</td>
                                    <td style={{ width: '200px' }}></td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'></td>

                                </tr>
                            </tbody>

                        </table>

                        <table style={{ margin: '1% 2%', fontSize: '14px' }}>
                            <thead>
                                <th>Sr.No.</th>
                                <th>Material Name</th>
                                <th>Size</th>
                            </thead>
                            <tbody>
                                {
                                    materialList.length > 0 ? 
                                    materialList?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.materialNm}</td>
                                            <td>
                                                {item?.sizewise?.length > 0 ?
                                                    <tbody>
                                                        <tr>
                                                            <td>Size</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.size}</td>
                                                            ))}
                                                        </tr>

                                                        <tr>
                                                            <td>Material Size</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.matsize}</td>
                                                            ))}
                                                        </tr>

                                                        <tr>
                                                            <td>qty</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.qty}</td>
                                                            ))}
                                                        </tr>

                                                    </tbody> : '-'
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td colSpan={3}>“Material has not been assigned for this quotation.”</td>
                                    </tr>
                                }
                            </tbody>
                        </table>



                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default QuotPatternView;
